/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { checkValidAlphaNumericAndSymbols, createBreadCrumbProps, keyPressValidationAlphaNumericAndSymbols, useEffectOnce } from '../../globalUtils/globalHooks';
import { clearDerivedConditionFormRedux, createDerivedConditon, fetchDerivedCondition, getAdvanceRuleEngineReducer, setDerivedConditionFormRedux, setDerivedConditionsListTableProps, updateDerivedConditon } from '../../rmsReduxStore/reduxExports';
import { CustomBreadCrumbs, CustomButtonGroup, CustomForm, DashboardHeader, DashboardLoader, RadioButton, useAppDispatch, useAppSelector } from '../../globalUtils/globalExports';
import { IDerivedConditionFormRedux } from '../../rmsReduxStore/advanceRuleEngineRedux/advanceRuleEngineType';
import './DerivedConditionForm.css';
import { Icon } from '../../globalUtils/globalIcons';
import { ICustomFormProps, IFormContentProp } from '../../globalUtils/CustomForm/CustomForm';
import { cloneDeep, isEqual } from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { ThreeDots } from 'react-loader-spinner';
import CustomDefinePlanButton from './CustomDefinePlanButton';
import { Id, toast } from 'react-toastify';

const initialFormData: IDerivedConditionFormRedux = {
  name: null,
  description: null,
  id: null,
  status: 'Draft',
  derivedCondition: null,
  imageURL: '',
  fileName: ''
}


const DerivedConditionForm: React.FC = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [formData,setFormData] = useState(initialFormData);
    const initialFormDataRef = useRef(initialFormData);
    const [showLoader,setShowLoader] = useState<boolean>(false);
    const [mode,setMode] = useState<string>(location?.state?.mode ? location?.state?.mode : 'Define');
    const {derivedConditionFormRedux,derivedConditionsListTableProps} = useAppSelector(getAdvanceRuleEngineReducer);
    const [errorMessageName, setErrorMessageName] = useState('');
    const [errorMessageDescription, setErrorMessageDescription] = useState('');
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [disableDerivedConditionButton, setDisableDerivedConditionButton] = useState(true);

    const successToast = (msg):Id => toast.success(msg);
    const errorToast = (msg):Id => toast.error(msg);

    const breadCrumbs = createBreadCrumbProps({
        breadCrumbProps: [
            {
                objectType: 'link',
                id: 'advanceRuleEngineDashboard',
            },
            {
                objectType: 'text',
                id: 'text',
                text: derivedConditionFormRedux?.name ?? ''
            }
        ]
    });

    const setHeaderText = useCallback(() => {
        if ((mode == 'View' || mode == 'Edit') && formData?.name) {
          return formData?.name
        } else return `${mode} Derived Condition`
      }, [mode, formData]);


    const handleFormDataChange = useCallback((val, formKey) => {
        const data = cloneDeep(formData);

        if (val?.id) {
            data[formKey] = val?.id;
        }
        else {
            data[formKey] = val;
        }
        if (formKey == 'name') {
            if (val.length > 90) {
            setErrorMessageName('Max characters allowed are 90')
            }
            else setErrorMessageName('')
            data[formKey] = data[formKey].charAt(0).toUpperCase() + data[formKey].slice(1);
        }
        if (formKey == 'description') {
            if (val.length > 500) {
            setErrorMessageDescription('Max characters allowed are 500')
            }
            else setErrorMessageDescription('')
            data[formKey] = data[formKey].charAt(0).toUpperCase() + data[formKey].slice(1);
        }
        setFormData(data);

        /// dispatch an event to save all the formdata inside the redux
        dispatch(setDerivedConditionFormRedux(data));
    
    }, [formData]);

    const handleDerivedConditionButtonClick = useCallback(() => {
        
        if (disableDerivedConditionButton) {
            errorToast('Derived Condition Name missing.');
            return;
        }

        navigate('/define-derived-condition',{ state: { mode: mode }});

    },[disableDerivedConditionButton,mode])


    const derivedConditionFormArray: IFormContentProp[] = [
        {
          rowCountClassName: 'grid-2',
          sectionHeading: '',
          formObject: [
            {
              formLabel: 'Condition Name',
              isRequired: true,
              objectType: 'input',
              selectDropdownProps: null,
              inputProps: {
                inputPlaceHolder: 'Type here',
                handleInputChange: (event): void => {
                  handleFormDataChange(checkValidAlphaNumericAndSymbols(event?.target?.value), 'name');
                },
                inputValue: formData?.name ?? '',
                inputType: 'string',
                inputFieldId: 'name',
                isRequired: false,
                isDisabled: mode === 'View',
                autoFocus: true,
                handleKeyPress: keyPressValidationAlphaNumericAndSymbols,
                errorMessage: errorMessageName
    
              },
              textAreaProps: null,
            }
          ],
        },
        {
          rowCountClassName: 'grid-2',
          sectionHeading: '',
          formObject: [
            {
              formLabel: 'Description',
              isRequired: true,
              objectType: 'text-area',
              selectDropdownProps: null,
              inputProps: null,
              textAreaProps: {
                inputPlaceHolder: mode !== 'View' ? 'Type here' : '',
                handleInputChange: (event): void => {
                  handleFormDataChange(event?.target?.value, 'description');
                },
                isRequired: false,
                inputValue: formData?.description ?? '',
                inputFieldId: 'description',
                isDisabled: mode === 'View',
                className: 'custom-resize',
                errorMessage: errorMessageDescription
              },
            },
          ],
        },
    ];

    const derivedConditionFormProps: ICustomFormProps = useMemo(() => {
        return {
          formContainerClassName: 'advance__rule__engine__derived__condition__form',
          formArray: derivedConditionFormArray
        };
      }, [formData, mode]);

    const disableSubmitButton = useCallback(() => {
        if(mode === 'View') return true;
        if(!formData?.name || !formData?.description || !formData?.derivedCondition)return true;
        return isEqual(formData,initialFormDataRef?.current);
    },[mode,formData])

    const handleSubmit = useCallback(async(status)=>{
      setShowLoader(true);
      const reqBody = {
        ...formData,
        status
      }
      const response = mode === 'Edit' ? await updateDerivedConditon(reqBody) : await createDerivedConditon(reqBody);
      if(response?.status === 200 || response?.status === 202){
        setShowLoader(false);
        successToast(mode === 'Edit' ? 'Derived condition updated.' : 'Derived condition added.');
        await dispatch(clearDerivedConditionFormRedux());
        const tableProps = cloneDeep(derivedConditionsListTableProps);
        tableProps.sortBy = mode === 'Edit' ? 'updatedAt' : 'createdAt';
        tableProps.order = 'descending';
        await dispatch(setDerivedConditionsListTableProps(tableProps));
        navigate('/rule-engine-advance',{ state: { activeTab: 'derivedConditions' } });
      } else {
        setShowLoader(false);
        errorToast(response?.data?.message);
      }
    },[formData,mode])

    const buttonsList = useMemo(() => {
      const btns = [
        {
          buttonText: mode === 'Define' ? 'Save As Draft' : 'Update Draft',
          buttonId: 'draft',
          btnClassName: disableSubmitButton() ? 'primary__btn disabled' : 'primary__btn',
  
          handleClick: () => handleSubmit('Draft'),
          isDisabled: disableSubmitButton(),
          buttonVariant: 'filled',
        },
        {
          buttonText: mode === 'Define' ? 'Publish' : 'Update',
          buttonId: 'submit',
          btnClassName: (disableSubmitButton() && !(mode === 'Edit' && formData?.status === 'Draft')) ? 'primary__btn disabled' : 'primary__btn',
  
          handleClick: () => handleSubmit('Not Draft'),
          isDisabled: (disableSubmitButton() && !(mode === 'Edit' && formData?.status === 'Draft')) ,
          buttonVariant: 'filled',
        },
        {
          buttonText: 'Cancel',
          buttonId: 'cancel',
          btnClassName: 'secondary__btn',
          handleClick: (): void => {
            navigate('/rule-engine-advance')
          },
          buttonVariant: 'outlined',
        },
      ];

      if(formData?.status && formData?.status === 'Not Draft') return btns?.slice(1);
      else return btns;
    }, [disableSubmitButton, formData, mode]);

    useEffect(()=>{
      if(derivedConditionFormRedux) {
        const data = cloneDeep(formData);
        data.id = derivedConditionFormRedux?.id ?? null;
        data.name = derivedConditionFormRedux?.name;
        data.description = derivedConditionFormRedux?.description;
        data.derivedCondition = derivedConditionFormRedux?.derivedCondition;
        data.imageURL = derivedConditionFormRedux?.imageURL;
        data.fileName = derivedConditionFormRedux?.fileName;
        data.status = derivedConditionFormRedux?.status;
        setFormData(data);
        if( derivedConditionFormRedux && derivedConditionFormRedux?.name?.length > 0) {
            setDisableDerivedConditionButton(false);
        } else setDisableDerivedConditionButton(true);
      }
    },[derivedConditionFormRedux])

    useEffectOnce(()=>{
      if(mode!=='Define' && location?.state?.derivedConditionId){
        dispatch(fetchDerivedCondition({id:location?.state?.derivedConditionId})).then(res=>{
          const data = cloneDeep(formData);
          data.id = res?.id ?? null;
          data.name = res?.name ?? null;
          data.description = res?.description ?? null;
          data.status = res?.status ?? 'Not Draft';
          data.imageURL = res?.imageURL ?? '';
          data.fileName = res?.fileName ?? '';
          data.derivedCondition = res?.derivedCondition ?? null;
          dispatch(setDerivedConditionFormRedux(data));
          initialFormDataRef.current = data;
          setFormData(data);
        })
      }
    })

    return (
       <>
        <DashboardLoader showLoader={showLoader} />
        <div className='advance__rule__engine__derived__condition__form__wrap'>
            <CustomBreadCrumbs breadCrumbs={breadCrumbs} />
            <div className='derived__condition__form__wrap-header'>
                <DashboardHeader
                    header={setHeaderText()}
                    headerClassName='derived__condition__wrap-header-custom'
                />
                {
                    mode !== 'Define' && (
                    <Icon
                        iconClassName={mode === 'View' ? 'rms__pencil__icon' : 'rms__view__icon'}
                        containerClassName='org__form_header-edit'
                        onIconClick={() => {
                        setMode(mode === 'View' ? 'Edit' : 'View')
                        }}
                    />

                    )
                }
            </div>
            <div className='advance__rule__engine___derived__condition__form-content'>
                <CustomForm {...derivedConditionFormProps} />
                <Typography sx={{ fontSize: '16px', marginTop: '5px', marginBottom: '10px', fontWeight: 500, fontFamily: 'Inter, sans-serif' }}>
                    Derived Condition
                </Typography>
                {
                    mode === 'View' ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
                        {!isImageLoaded && (
                            <ThreeDots
                                height="40"
                                width="40"
                                radius="9"
                                color="#01BFBF"
                                ariaLabel="three-dots-loading"
                                visible={true}
                            />
                        )}
                        <img
                            src={formData?.imageURL}
                            alt="Execution Plan"
                            style={{
                            display: isImageLoaded ? 'block' : 'none',
                            width: '100%',
                            maxWidth: '800px',
                            height: 'auto',
                            borderRadius: '8px',
                            scale: 0.75,
                            }}
                            onLoad={() => setIsImageLoaded(true)}
                        />
                        </div>
                    ) : (
                        <CustomDefinePlanButton
                            planMode={formData?.derivedCondition && formData?.derivedCondition != null ? 'Edit' : 'Define'} 
                            handleClick={handleDerivedConditionButtonClick} 
                            editLabel={'Derived condition successfully \ndefined'} 
                            defineLabel={'Define Derived Condition'} 
                            description={''}                            
                        />
                    )
                }
                <div className='advance__rule__engine__derived__condition__footer'>
                    <div className='derived__condition__btnList-footer'>
                        <CustomButtonGroup
                            buttonsList={buttonsList}
                            buttonGroupClassName='button__group__footer'
                        />
                    </div>
                </div>
            </div>
        </div>
       </>
    )
}

export default DerivedConditionForm;